import { useEffect, useRef } from 'react';
import TawkMessengerReact from '@tawk.to/tawk-messenger-react';
import CryptoJS from 'crypto-js';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '../../redux/hooks';

interface ICoach {
  name: string;
  email: string;
}

interface TawkMessengerRefType {
  setAttributes: (_details: { name: string; email: string; hash: string }) => void;
}

const customStyle = {
  visibility: {
    desktop: {
      xOffset: '15',
      yOffset: '50',
      position: 'bl',
    },
  },
};

function generateHMAC(email: string, apiKey: string): string {
  const hash = CryptoJS.HmacSHA256(email, apiKey).toString(CryptoJS.enc.Hex);
  return hash;
}

export default function TawkMessenger({ name, email }: ICoach) {
  const tawkMessengerRef = useRef<TawkMessengerRefType | null>(null);
  const siteAPIKey = process.env.REACT_APP_TWAK_SITE_API_KEY as string;
  const isLoggedIn = useAppSelector((state) => state.coach.loggedInStatus);
  const {
    i18n: { language },
  } = useTranslation();

  const onLoad = () => {
    if (tawkMessengerRef.current && name && email) {
      tawkMessengerRef.current.setAttributes({
        name,
        email,
        hash: generateHMAC(email as string, siteAPIKey),
      });
    }
  };

  useEffect(() => {
    if (!isLoggedIn) {
      if (tawkMessengerRef.current) {
        tawkMessengerRef.current = null;
      }
    }
  }, [isLoggedIn]);

  return (
    <div className="App">
      {language.split('-')[0] === 'en' && (
        <TawkMessengerReact
          propertyId={`${process.env.REACT_APP_TWAK_PROPERTY_ID}`}
          widgetId={process.env.REACT_APP_TWAK_WIDGET_ID_ENGLISH}
          onLoad={onLoad}
          ref={tawkMessengerRef}
          customStyle={customStyle}
        />
      )}
      {language.split('-')[0] === 'pt' && (
        <TawkMessengerReact
          propertyId={`${process.env.REACT_APP_TWAK_PROPERTY_ID}`}
          widgetId={process.env.REACT_APP_TWAK_WIDGET_ID_PORTUGUES}
          onLoad={onLoad}
          ref={tawkMessengerRef}
          customStyle={customStyle}
        />
      )}
    </div>
  );
}
